module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('h2', [_vm._v("Welkom bij")]), _vm._v(" "), _c('h1', {
    staticClass: "authentication__title"
  }, [_vm._v("Boodschapp")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "login"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("Inloggen")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('router-link', {
    attrs: {
      "to": "register"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "blue"
    }
  }, [_vm._v("Registreren")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09842968","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/authenticate/Welcome.vue
// module id = 478
// module chunks = 1